import React from 'react';
import { Row, Col, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import bg2 from 'assets/img/generic/bg-2.jpg';
import Section from 'components/common/Section';
import { useTranslation } from 'react-i18next';
import mercadoLibreLogo from 'assets/img/logos/mercadolibre45470890.png';

const MercadoLibreLockup = ({ className = '' }) => (
  <span
    className={`d-inline-flex align-items-center rounded-pill px-2 py-1 ${className}`.trim()}
    style={{ backgroundColor: '#ffe600', color: '#2d3277', gap: '0.45rem' }}
  >
    <img
      src={mercadoLibreLogo}
      alt="Mercado Libre"
      style={{ width: '1.45rem', height: '1.45rem', objectFit: 'contain', borderRadius: '999px', backgroundColor: '#fff', padding: '0.08rem' }}
    />
    <span className="fw-semi-bold text-uppercase" style={{ letterSpacing: '0.04em', fontSize: '0.72rem', lineHeight: 1 }}>
      Mercado Libre
    </span>
  </span>
);

const Cta = () => {
  const { t } = useTranslation();

  return (
    <Section overlay image={bg2} position="center top" className="light bg-dark">
      <Row className="justify-content-center text-center">
        <Col lg={8}>
          <p className="fs-3 fs-sm-4 text-white">
            {t('LANDING.CTA_TEXT')}
          </p>
          <Button
            as={Link}
            to="/login"
            variant="light"
            size="lg"
            className="rounded-pill mt-4 fs-0 py-2 px-5 fw-semi-bold d-inline-flex align-items-center"
          >
            <MercadoLibreLockup className="me-2" />
            {t('LANDING.CTA_BUTTON')}
            <FontAwesomeIcon icon="sign-in-alt" className="ms-2" />
          </Button>
        </Col>
      </Row>
    </Section>
  );
};

export default Cta;
